import { useState, useEffect } from "react";
import Banner from "components/common/Banner";
import loadWebpImage from "utils/loadWebpImage";

import BannerImage from "assets/images/banner_achievements.webp";
import BannerImageFallback from "assets/images/banner_achievements.png";

import BannerImageMobile from "assets/images/banner_achievements_mobile.webp";
import BannerImageMobileFallback from "assets/images/banner_achievements_mobile.png";
import AchievementsOverlay from "components/Achievements/AchievementsOverlay";
import AchievementsOverlayMobile from "components/Achievements/AchievementsOverlay/AchievementsOverlayMobile";

const AchievementsBanner = () => {
  const [banner, setBanner] = useState("");
  const [bannerMobile, setBannerMobile] = useState("");

  useEffect(() => {
    loadWebpImage(BannerImage, BannerImageFallback, setBanner);
    loadWebpImage(
      BannerImageMobile,
      BannerImageMobileFallback,
      setBannerMobile
    );
  }, []);

  return (
    <section role="banner">
      <Banner background={banner} width="100vw" height="45vw">
        <Banner.Overlay center={false}>
          <AchievementsOverlay />
        </Banner.Overlay>
      </Banner>

      <Banner
        mobileBackground={bannerMobile}
        width="100vw"
        height="130vw"
        isMobile
      >
        <Banner.Overlay center={false} isMobile>
          <AchievementsOverlayMobile />
        </Banner.Overlay>
      </Banner>
    </section>
  );
};

export default AchievementsBanner;
